import { createFileRoute, redirect } from '@tanstack/react-router'

/** Every role's home is Přehled (owner, 2026-07-30). */
export const Route = createFileRoute('/klient/')({
  beforeLoad: () => {
    throw redirect({ to: '/klient/prehled' })
  },
})
